import {
  CustomerSubscriptionSchema,
  SubscriptionEditingActionSchema,
  SubscriptionSelfServiceSettingsSchema,
} from "@redotech/redo-subscriptions-common/self-service";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getCustomerSubscriptions = {
  name: "getCustomerSubscriptions" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({
    settings: SubscriptionSelfServiceSettingsSchema,
    timeZone: z.string(),
    requiresEmailVerification: z.boolean(),
    subscriptions: z.array(CustomerSubscriptionSchema),
  }),
};
export const modifyCustomerSubscription = {
  name: "modifyCustomerSubscription" as const,
  input: z.object({
    orderId: zExt.objectId(),
    subscriptionId: z.number().int().positive(),
    action: SubscriptionEditingActionSchema,
  }),
  output: z.object({ success: z.literal(true) }),
};
